import React, { Fragment, useContext } from "react";

import { PageTitle } from "layout-components";
import Historique from "example-components/Historique";

export default function Visualisation(props) {
  return (
    <Fragment>
      <PageTitle
        titleHeading={"Historique du BESC"}
        titleDescription={
          "Liste des changements effectués sur le BESC depuis sa création jusqu'à son état actuel "
        }
      />
      <Historique bescId={props.match.params.id} />
    </Fragment>
  );
}
